import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthService } from "./auth.service";
import { catchError, map } from "rxjs/operators";
import { environment } from "environments/environment";
import { AppConsts } from "@shared/AppConsts";
import { AppPreBootstrap } from "AppPreBootstrap";

@Injectable({
  providedIn: "root",
})
export class CustomAuthGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  private lastUrlChecked: string | null = null;

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    if (state.url === this.lastUrlChecked) {
      return of(true);
    }
    this.lastUrlChecked = state.url;

    if (!this.authService.hasValidToken()) {
      return this.refreshToken();
    }

    let oldToken = abp.utils.getCookieValue(abp.auth.tokenCookieName);

    // Kiểm tra token hiện tại
    const currentToken = this.authService.getCurrentToken();
    return this.introspectToken(currentToken);
  }

  private refreshToken(): Observable<boolean> {
    return this.authService.refreshToken().pipe(
      map((newUser) => {
        if (!newUser) {
          this.authService.clearToken();
          this.redirectToLogin();
          return false;
        }
        let token = AppPreBootstrap.getTokenLocalstorage(
          AppConsts.authorization.newAccessToken
        );
        this.setOldTokenCookie(token);

        this.authService.reloadConfig().subscribe((res) => {
          return true;
        });
        return true;
      }),
      catchError((err) => {
        this.authService.clearToken();
        this.redirectToLogin();
        return of(false);
      })
    );
  }

  private introspectToken(token: string): Observable<boolean> {
    return this.authService.introspectToken(token).pipe(
      map((isActive) => {
        if (!isActive) {
          this.authService.clearToken();
          this.redirectToLogin();
          return false;
        }
        this.authService.reloadConfig().subscribe((res) => {});
        this.setOldTokenCookie(token);
        return true;
      }),
      catchError((err) => {
        this.authService.clearToken();
        this.redirectToLogin();
        return of(false);
      })
    );
  }
  private setOldTokenCookie(token: string) {
    let oldToken = abp.utils.getCookieValue(abp.auth.tokenCookieName);
    let encrptedAuthToken = AppPreBootstrap.getTokenLocalstorage(
      AppConsts.authorization.encrptedAuthTokenName
    );
    let newAccessToken = AppPreBootstrap.getTokenLocalstorage(
      AppConsts.authorization.newAccessToken
    );

    if (oldToken && encrptedAuthToken) {
      return;
    }
    this.authService.authenticateSaleApp(token).subscribe(
      (result) => {
        let accessToken = result.success ? result.result.accessToken : null;
        let encryptedRaw = result.success
          ? result.result.encryptedAccessToken
          : null;
        if (!accessToken) {
          this.authService.clearToken();
          this.redirectToLogin();
          return;
        }
        abp.auth.setToken(accessToken);

        AppPreBootstrap.setEncryptedTokenLocalstorage(encryptedRaw);

        window.location.reload();
      },
      (error) => {
        this.authService.clearToken();
        if (newAccessToken) {
          this.authService.logout(newAccessToken).subscribe();
        }
        this.redirectToLogin();
      }
    );
  }
  private redirectToLogin() {
    const currentUrl = encodeURIComponent(environment.homepageUrl);
    const loginUrl = `${environment.authUrl}auth/login?returnUrl=${currentUrl}`;
    location.href = loginUrl;
  }
}
